import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Waves, ClipboardCheck, TrendingDown, TrendingUp, Crown, Activity } from "lucide-react";
import { ink } from "../lib/ink";

// CRM 获客健康度总览卡: 公海超期 / 复核积压 / 流失趋势 / 认领冠军
export default function CrmHealthCard({ api, region, zh }) {
  const nav = useNavigate();
  const [h, setH] = useState(null);
  useEffect(() => {
    const q = region && region !== "all" ? `?region=${region}` : "";
    api.get(`/crm/health-overview${q}`).then(({ data }) => setH(data)).catch(() => setH(null));
  }, [region]); // eslint-disable-line

  if (!h) return null;
  const fmtH = (v) => v >= 24 ? `${(v / 24).toFixed(1)}${zh ? "天" : "d"}` : `${v}${zh ? "h" : "h"}`;
  const churnUp = h.churnDelta > 0;

  const Tile = ({ testid, icon: Icon, tint, label, value, sub, subTint, onClick }) => (
    <button onClick={onClick} data-testid={testid}
      className="text-left rounded-xl border border-slate-100 bg-slate-50 hover:bg-slate-100 transition-colors p-3.5 flex flex-col gap-1">
      <div className="flex items-center gap-1.5 text-[11px] font-semibold" style={ink(tint)}><Icon className="h-3.5 w-3.5" />{label}</div>
      <div className="text-2xl font-black text-slate-900 leading-none">{value}</div>
      {sub && <div className="text-[11px]" style={ink(subTint || "#64748b")}>{sub}</div>}
    </button>
  );

  return (
    <div className="rounded-2xl p-4 border border-slate-200 bg-white" data-testid="crm-health-card">
      <div className="flex items-center gap-2 mb-3">
        <Activity className="h-4.5 w-4.5 text-emerald-600" />
        <p className="text-[14px] font-bold text-slate-900">{zh ? "CRM 获客健康度" : "Acquisition Health"}</p>
        <span className="text-[11px] text-slate-400">{zh ? "一览全局，及时兜底" : "At a glance"}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5">
        <Tile testid="health-pool" icon={Waves} tint="#0369a1"
          label={zh ? "公海超期待认领" : "Pool stale"}
          value={h.poolStale}
          sub={zh ? `公海共 ${h.poolTotal} · 超 ${h.poolStaleDays} 天` : `of ${h.poolTotal}`}
          subTint={h.poolStale > 0 ? "#dc2626" : undefined}
          onClick={() => nav("/crm/pool")} />
        <Tile testid="health-review" icon={ClipboardCheck} tint="#b45309"
          label={zh ? "待复核积压" : "Review pending"}
          value={h.reviewPending}
          sub={h.reviewPending > 0 ? (zh ? `最久 ${fmtH(h.reviewOldestHours)}` : `oldest ${fmtH(h.reviewOldestHours)}`) : (zh ? "无积压" : "clear")}
          subTint={h.reviewOldestHours >= h.reviewSlaHours ? "#dc2626" : undefined}
          onClick={() => nav("/crm/mm-review")} />
        <Tile testid="health-churn" icon={churnUp ? TrendingUp : TrendingDown} tint={churnUp ? "#dc2626" : "#047857"}
          label={zh ? "本月流失" : "Churn (mo)"}
          value={h.churnThisMonth}
          sub={`${zh ? "上月" : "last"} ${h.churnLastMonth} · ${h.churnPct > 0 ? "+" : ""}${h.churnPct}%`}
          subTint={churnUp ? "#dc2626" : "#047857"}
          onClick={() => nav("/crm/lost-analytics")} />
        <Tile testid="health-champion" icon={Crown} tint="#a16207"
          label={zh ? "认领冠军" : "Champion"}
          value={h.champion ? h.champion.sales : (h.currentLeader ? h.currentLeader.sales : "—")}
          sub={h.champion ? `${h.champion.month}` : (h.currentLeader ? (zh ? "本月领跑" : "leading") : (zh ? "暂无" : "—"))}
          onClick={() => nav("/crm/hall-of-fame")} />
      </div>
    </div>
  );
}
